import type {
  LoadRequest,
  VisibilityPluginConfig,
} from "@foundation-player/api";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the visibility plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v2/api/type/load-request/#plugins
 * @see https://docs.player.foundation/v2/api/type/load-request/#foundationpluginvisibility
 * @see https://docs.player.foundation/v2/api/type/visibility-plugin-config/
 */
export class PluginAutopause extends Plugin {
  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoadRequestPlugins(): LoadRequest["plugins"] {
    const visibilityPluginConfig: VisibilityPluginConfig = {
      enabled: true,
      pauseAds: true,
      pauseContent: true,
    };
    return {
      "foundation.plugin.visibility": visibilityPluginConfig,
    };
  }
}
